import React from "react";
import GoogleSignUp from "./Signup/GoogleSignUp";

const WelcomeScreen = () => {
  const user = JSON.parse(localStorage.getItem("user")); // Retrieve the user from localStorage if logged in

  // Function to get a greeting based on the time of day
  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good Morning";
    } else if (currentHour < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-blue-50">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">
        {getGreeting()}, {user ? user.display_name : "Guest"}!
      </h1>
      <p className="text-lg text-gray-600">
        Welcome to Linkly! We're glad you're here.
      </p>
      <p className="text-md text-gray-500 mt-2">
        Explore the platform and start customizing your profile.
      </p>
      <GoogleSignUp />
    </div>
  );
};

export default WelcomeScreen;
